import { render, staticRenderFns } from "./documentForm.vue?vue&type=template&id=10682350&scoped=true&"
import script from "./documentForm.vue?vue&type=script&lang=js&"
export * from "./documentForm.vue?vue&type=script&lang=js&"
import style0 from "./documentForm.vue?vue&type=style&index=0&id=10682350&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10682350",
  null
  
)

export default component.exports